/**
 * Which routes show the tab bar — one answer, for everything that has to know.
 *
 * `App` decides whether to render `<Tabbar/>`, and the toast has to clear it. The toast's offset
 * was `tabbar-height + safe-bottom + 32px` unconditionally, so on a detail, submit, support,
 * author or leaderboard screen — none of which have a tab bar — it floated a full 56px above where
 * it belonged. Two components with two ideas of the same piece of layout, one of them stale.
 */

export const ROOT_PATHS = new Set(['/', '/search', '/favorites', '/profile']);

export function hasTabbar(pathname: string): boolean {
  return ROOT_PATHS.has(pathname);
}
